(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDashboardKioskController', KiosksDashboardKioskController);

    KiosksDashboardKioskController.$inject = ['$state', '$timeout', '$scope', 'pagingParams', 'Kiosks', '$uibModal'];

    function KiosksDashboardKioskController($state, $timeout, $scope, pagingParams, Kiosks, $uibModal) {
        var vm = this;

        vm.dashboardList = pagingParams.selectedDashboards;
        vm.kiosksDashboardkiosk = pagingParams.kiosk;
        vm.currentState = "kiosk-dashboard-kiosk";
        vm.preselect = {};
        vm.kiosk = localStorage.getItem(vm.currentState);
        if (vm.kiosk !== null && vm.kiosk !== "null" && vm.kiosk !== undefined) {
            vm.kiosk = JSON.parse(vm.kiosk);
            if (Object.keys(vm.kiosk).length > 0) {
                if (vm.kiosksDashboardkiosk === vm.kiosk.kiosksDashboardkiosk || vm.kiosksDashboardkiosk === {}
                || vm.kiosksDashboardkiosk == null || Object.keys(vm.kiosksDashboardkiosk).length === 0) {
                    vm.dashboardList = vm.kiosk.dashboardList;
                    vm.kiosksDashboardkiosk = vm.kiosk.kiosksDashboardkiosk;
                } else {
                    setLocalStorage();
                }
            } else
                setLocalStorage();
        } else {
            setLocalStorage();
        }

        function setLocalStorage() {
            vm.kiosk = {};
            vm.kiosk.dashboardList = vm.dashboardList;
            vm.kiosk.kiosksDashboardkiosk = vm.kiosksDashboardkiosk;
            localStorage.setItem(vm.currentState, JSON.stringify(vm.kiosk));
        }

        vm.singleInterval = false;
        vm.time = [];
        if(vm.kiosksDashboardkiosk.id) {
            var times = vm.kiosksDashboardkiosk.interval.split(",");
            if(times.length == 1) {
                vm.dashboardInterval = times[0];
            } else {
                vm.singleInterval = true;
                var i = 0;
                vm.dashboardList.forEach(function (val) {
                    vm.time[val.name] = times[i];
                    i = i + 1;
                })
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:kiosksDashboardUpdate', result);
            vm.isSaving = false;
            $state.go('kiosks');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            var composite = "";
            var i = 1;
            if(vm.singleInterval) {
                vm.dashboardList.forEach(function (val) {
                    val.order = i;
                    i = i + 1;
                    delete val.selected;
                    delete val.disabledCheck;
                    composite = composite + vm.time[val.name] + ","
                });
                vm.kiosksDashboardkiosk.interval = composite.substr(0, composite.length - 1);
            } else {
                vm.dashboardList.forEach(function (val) {
                    val.order = i;
                    i = i + 1;
                    delete val.selected;
                    delete val.disabledCheck;
                });
                vm.kiosksDashboardkiosk.interval = vm.dashboardInterval;
            }
            vm.kiosksDashboardkiosk.dashboards = vm.dashboardList;
            if(vm.kiosksDashboardkiosk.id) {
                Kiosks.update(vm.kiosksDashboardkiosk, onSaveSuccess, onSaveError);
            } else {
                Kiosks.save(vm.kiosksDashboardkiosk, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('kiosks');
        };

        vm.moveUp = function(index) {
            var dashboard = vm.dashboardList[index];
            vm.dashboardList.splice(index, 1);
            vm.dashboardList.splice(index - 1, 0, dashboard);
            setLocalStorage();
            // $scope.$apply();
        }

        vm.moveDown = function(index) {
            var dashboard = vm.dashboardList[index];
            vm.dashboardList.splice(index, 1);
            vm.dashboardList.splice(index + 1, 0, dashboard);
            setLocalStorage();
        }

        vm.deleteDashboard = function (id) {
            var entity = {};
            entity.kioskId = vm.kiosksDashboardkiosk.id;
            entity.dashboard = getDashboard(id);
            $uibModal.open({
                templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosk-dashboard-kiosk-delete.html',
                controller: 'KioskDashboardDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: entity
                }
            }).result.then(function () {
                removeDashboard(entity.dashboard.id);
                $state.transitionTo('kiosks-dashboard-kiosk', {}, {reload: true});
            }, function () {
                $state.go('kiosks-dashboard-kiosk');
            });
        }

        function removeDashboard(id) {
            removeFromArray(vm.kiosksDashboardkiosk.dashboards, id);
            removeFromArray(vm.dashboardList, id);
            setLocalStorage();
        }

        function removeFromArray(array, id) {
            var i = 0;
            while (i < array.length) {
                if (array[i].id === id)
                    break;
                i ++;
            }
            array.splice(i, 1);
        }

        function getDashboard(id) {
            for (var i = 0; i < vm.kiosksDashboardkiosk.dashboards.length; i++) {
                if (vm.kiosksDashboardkiosk.dashboards[i].id === id)
                    return vm.kiosksDashboardkiosk.dashboards[i];
            }
            return {};
        }

        vm.addDashboard = function() {
            $state.go('kiosks-dashboards');
        }
    }
})();
